var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 0C2.504 0 0 2.504 0 5.6C0 9.8 5.6 16 5.6 16C5.6 16 11.2 9.8 11.2 5.6C11.2 2.504 8.696 0 5.6 0ZM1.6 5.6C1.6 3.392 3.392 1.6 5.6 1.6C7.808 1.6 9.6 3.392 9.6 5.6C9.6 7.904 7.296 11.352 5.6 13.504C3.936 11.368 1.6 7.88 1.6 5.6Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60059 7.60034C6.70516 7.60034 7.60059 6.70491 7.60059 5.60034C7.60059 4.49577 6.70516 3.60034 5.60059 3.60034C4.49602 3.60034 3.60059 4.49577 3.60059 5.60034C3.60059 6.70491 4.49602 7.60034 5.60059 7.60034Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSmall);
export default __webpack_public_path__ + "static/media/Location_Small.1b17fb094e82b36a4ac40b1be300f390.svg";
export { ForwardRef as ReactComponent };